import { useQuery } from "@tanstack/react-query";
import { useThoughtSpotAPI } from "@/api";

export const LiveboardsQueryKey = "liveboards";

export function useLiveboards() {
  const api = useThoughtSpotAPI();

  return useQuery({
    queryKey: [LiveboardsQueryKey],
    queryFn: async () => {
      const r = await api.getThoughtspotLiveboards();
      return r.data;
    },
  });
}
